const currencyComma = (val, decimalPlaces) =>{
    if(!val) return ''
    if (isNaN(val)) return val;
    if (isNaN(decimalPlaces) || !decimalPlaces) {
      decimalPlaces = 0;
    }
    return '$' + parseFloat(val).toFixed(decimalPlaces).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  
  export default currencyComma
  